export default __webpack_public_path__ + "static/media/files.1e736d6d.svg";